if (!customElements.get('lightlore-welcome-offer')) {
  customElements.define('lightlore-welcome-offer', class LightLoreWelcomeOffer extends HTMLElement {
    connectedCallback() {
      this.tab = this.querySelector('.ll-offer__tab');
      this.dialog = this.querySelector('.ll-offer__dialog');
      this.backdrop = this.querySelector('.ll-offer__backdrop');
      this.preview = new URLSearchParams(window.location.search).get('offer_preview') === '1';
      this.serverSuccess = this.querySelector('[data-offer-success]');

      if (this.serverSuccess) {
        this.saveCode(this.serverSuccess.querySelector('[data-offer-code]')?.textContent.trim());
      } else {
        this.restoreCode();
      }

      this.tab.addEventListener('click', () => this.open());
      this.querySelector('.ll-offer__close').addEventListener('click', () => this.close());
      this.backdrop.addEventListener('click', () => this.close());
      this.onKeydown = (event) => this.handleKeydown(event);
      document.addEventListener('keydown', this.onKeydown);
      this.onExternalOpen = (event) => {
        event.preventDefault();
        this.open();
      };
      document.querySelectorAll('[data-ll-offer-open]').forEach((trigger) => {
        trigger.addEventListener('click', this.onExternalOpen);
      });
      this.addEventListener('click', (event) => {
        const copyButton = event.target.closest('[data-offer-copy]');
        if (copyButton) this.copyCode(copyButton);
        const applyButton = event.target.closest('[data-offer-apply]');
        if (applyButton) {
          event.preventDefault();
          this.applyCode(applyButton);
        }
      });

            // 浮标常驻右下角，绝不自动弹窗，静等客户点击
      this.tab.hidden = false;
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKeydown);
      window.removeEventListener('scroll', this.onScroll);
      window.clearTimeout(this.delayTimer);
      document.querySelectorAll('[data-ll-offer-open]').forEach((trigger) => {
        trigger.removeEventListener('click', this.onExternalOpen);
      });
      document.body.classList.remove('ll-offer-open');
    }

    getSavedCode() {
      try {
        return JSON.parse(localStorage.getItem(this.dataset.storageKey) || '{}').code || '';
      } catch (error) {
        return '';
      }
    }

    saveCode(code) {
      if (!code) return;
      this.savedCode = code;
      try {
        localStorage.setItem(this.dataset.storageKey, JSON.stringify({ code }));
      } catch (error) {}
      this.tab.querySelector('[data-offer-tab-label]').textContent = 'Gift';
    }

    restoreCode() {
      const code = this.getSavedCode();
      if (!code) return;
      this.saveCode(code);
      const savedPanel = this.querySelector('[data-offer-saved]');
      const signupPanel = this.querySelector('[data-offer-signup]');
      if (savedPanel && signupPanel) {
        signupPanel.hidden = true;
        savedPanel.hidden = false;
        savedPanel.querySelector('[data-offer-saved-code]').textContent = code;
        this.querySelector('#LightLoreWelcomeTitle').id = 'LightLoreWelcomeSignupTitle';
        savedPanel.querySelector('h2').id = 'LightLoreWelcomeTitle';
      }
    }

    async requestCart(path, body) {
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 12000);
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}${path}`, {
          method: body ? 'POST' : 'GET',
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          ...(body ? { body: JSON.stringify(body) } : {}),
          signal: controller.signal,
        });
        if (!response.ok) throw new Error('Cart request failed');
        const cart = await response.json();
        if (!Array.isArray(cart.items) || !Number.isInteger(cart.item_count)) {
          throw new Error('Unexpected cart response');
        }
        return cart;
      } finally {
        window.clearTimeout(timeout);
      }
    }

    getDiscountApplications(cart) {
      return [
        ...(cart.cart_level_discount_applications || []),
        ...(cart.items || []).flatMap((item) =>
          (item.line_level_discount_allocations || []).map((allocation) => allocation.discount_application)
        ),
      ].filter((application) => application?.type === 'discount_code');
    }

    async applyCode(button) {
      if (this.applying) return;
      if (button.dataset.offerComplete === 'true') {
        this.close();
        return;
      }
      const code = this.savedCode;
      if (!code) return;
      const message = button.closest('.ll-offer__success').querySelector('[data-offer-apply-message]');
      this.applying = true;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'Applying your offer…';
      message.textContent = '';
      try {
        const cart = await this.requestCart('cart.js');
        // Keep existing codes: Shopify decides which eligible offers can combine.
        const codes = new Set([
          ...(cart.discount_codes || []).map((discount) => discount.code),
          ...this.getDiscountApplications(cart).map((discount) => discount.title),
          code,
        ].filter(Boolean).map((value) => value.toUpperCase()));
        if (codes.size > 5) {
          message.textContent = 'Your cart already has several offers. You can enter this code at checkout to choose your discount.';
          button.textContent = 'Try again';
          return;
        }
        const updatedCart = await this.requestCart('cart/update.js', { discount: [...codes].join(',') });
        const applied = (updatedCart.discount_codes || []).some((discount) =>
          discount.code?.toUpperCase() === code.toUpperCase() && discount.applicable === true
        ) || this.getDiscountApplications(updatedCart).some((discount) =>
          discount.title?.toUpperCase() === code.toUpperCase() && Number(discount.total_allocated_amount) > 0
        );
        if (applied) {
          message.textContent = 'Your 15% offer is applied to this cart. No copying needed.';
          button.textContent = 'Continue shopping';
          button.dataset.offerComplete = 'true';
        } else if (updatedCart.item_count === 0) {
          message.textContent = 'Your code is saved. Add a piece, then check your offer at checkout.';
          button.textContent = 'Continue shopping';
          button.dataset.offerComplete = 'true';
        } else {
          message.textContent = 'Your code is saved, but it could not be applied to this cart. Check any other offers, or enter this code at checkout.';
          button.textContent = 'Try again';
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          // Refresh cart totals without leaving the current draft preview.
          try {
            Promise.resolve(publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'lightlore-welcome-offer', cartData: updatedCart,
            })).catch(() => {});
          } catch (error) {}
        }
      } catch (error) {
        message.textContent = 'We could not apply your offer right now. Try again, or copy the code above and enter it at checkout.';
        button.textContent = 'Try again';
      } finally {
        this.applying = false;
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    }

    showTabIfReady() {
      if (this.delayPassed && window.scrollY >= Number(this.dataset.scroll || 0)) {
        this.tab.hidden = false;
        this.open();
        window.removeEventListener('scroll', this.onScroll);
      }
    }

    open() {
      if (!this.applying) {
        this.querySelectorAll('[data-offer-apply]').forEach((button) => {
          delete button.dataset.offerComplete;
          button.textContent = 'Apply my 15% offer';
        });
        this.querySelectorAll('[data-offer-apply-message]').forEach((message) => {
          message.textContent = 'No copying needed. Apply your offer here and keep browsing.';
        });
      }
      this.previouslyFocused = document.activeElement;
      this.tab.hidden = false;
      this.dialog.hidden = false;
      this.backdrop.hidden = false;
      this.tab.setAttribute('aria-expanded', 'true');
      document.body.classList.add('ll-offer-open');
      this.querySelector('[data-offer-signup]:not([hidden]) input, [data-offer-success] [data-offer-copy], [data-offer-saved]:not([hidden]) [data-offer-copy], .ll-offer__close')?.focus();
    }

    close() {
      this.dialog.hidden = true;
      this.backdrop.hidden = true;
      this.tab.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('ll-offer-open');
      if (this.previouslyFocused && this.previouslyFocused.isConnected) this.previouslyFocused.focus();
      else this.tab.focus();
    }

    handleKeydown(event) {
      if (this.dialog.hidden) return;
      if (event.key === 'Escape') {
        this.close();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = [...this.dialog.querySelectorAll('button:not([disabled]), a[href], input:not([disabled])')]
        .filter((element) => element.getClientRects().length);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    async copyCode(button) {
      const code = button.closest('.ll-offer__success').querySelector('.ll-offer__code').textContent.trim();
      try {
        await navigator.clipboard.writeText(code);
        button.textContent = 'Copied';
      } catch (error) {
        const selection = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(button.closest('.ll-offer__success').querySelector('.ll-offer__code'));
        selection.removeAllRanges();
        selection.addRange(range);
      }
    }
  });
}
